




















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
// import { Upload } from 'element-ui';
@Component({
  name: 'lb-upload'
  // components: {
  //   'el-upload': Upload
  // }
})
export default class extends Vue {
  @Prop() private type!: string;
  @Prop({ required: true }) private action!: string;
  @Prop({ default: 'file' }) private name!: string;
  @Prop() private data!: object;
  @Prop() private headers!: object;
  @Prop({ type: Boolean, default: false }) private withCredentials!: boolean;
  @Prop({ type: Boolean, default: false }) private multiple!: boolean;
  @Prop() private accept!: string;
  @Prop() private onStart!: any;
  @Prop() private onProgress!: any;
  @Prop() private onSuccess!: any;
  @Prop() private onError!: any;
  @Prop() private onChange!: any;
  @Prop() private beforeUpload!: any;
  @Prop() private beforeRemove!: any;
  @Prop({ type: Boolean, default: false }) private drag!: boolean;
  @Prop() private onPreview!: any;
  @Prop() private onRemove!: any;
  @Prop() private fileList!: any[];
  @Prop({ type: Boolean, default: false }) private autoUpload!: boolean;
  @Prop() private listType!: string;
  @Prop() private httpRequest!: any;
  @Prop({ type: Boolean, default: false }) private disabled!: boolean;
  @Prop() private limit!: number;
  @Prop() private onExceed!: any;
  @Prop({ type: Boolean, default: true }) private showFileList!: boolean;
}
